import type { TFunction } from 'i18next';

import { serverErrorCode } from '@/lib/serverErrorCode';

export function friendlyAnimate2dError(raw: string | null | undefined, t: TFunction): { title: string; detail?: string } | null {
  if (!raw) return null;
  const code = serverErrorCode(raw);
  if (code === 'video2d_unavailable')            return { title: t('animate2d.errors.unavailable.title'), detail: t('animate2d.errors.unavailable.detail') };
  // Qavatar#10 (I-416): la creazione e' riservata ad `administrator`, 403 `avatar_creation_reserved`.
  if (code === 'avatar_creation_reserved')       return { title: t('animate2d.errors.creationReserved.title'), detail: t('animate2d.errors.creationReserved.detail') };
  if (code === 'user_daily_video2d_cap')         return { title: t('animate2d.errors.dailyCap.title'), detail: t('animate2d.errors.dailyCap.detail') };
  if (code === 'too_many_concurrent_videos')     return { title: t('animate2d.errors.tooManyConcurrent.title'), detail: t('animate2d.errors.tooManyConcurrent.detail') };
  if (code === 'avatar_video_capacity_reached')  return { title: t('animate2d.errors.capacity.title'), detail: t('animate2d.errors.capacity.detail') };
  if (code === 'prompt_too_short')               return { title: t('animate2d.errors.promptTooShort') };
  if (code === 'prompt_too_long')                return { title: t('animate2d.errors.promptTooLong') };
  if (code === 'no_source_image')                return { title: t('animate2d.errors.noSourceImage') };
  if (code === 'avatar_not_active')              return { title: t('animate2d.errors.notActive') };
  // Il dettaglio è il codice del server, com'è: non si traduce.
  return { title: t('animate2d.errors.generic'), detail: raw };
}
